// @ts-nocheck
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { FormFieldUploadedFileType } from "@store/Framework/Types/FormField";

const baseUrl = "/api/v1/custom/forms";

export interface SubmitPackagingAdviceFormApiParameter extends ApiParameter {
    attachments?: FormFieldUploadedFileType[];
    emailAddress: string;
    firstName: string;
    lastName: string;
    requestDetails: string;
    phoneNumber?: string;
    productType: string;
    referenceProductId?: string;
    soldToNumber: string;
    shipToNumber: string;
}

export interface SubmitPackagingAdviceFormModel {
    success: boolean;
}

export async function submitPackagingAdviceForm(
    parameter: SubmitPackagingAdviceFormApiParameter,
): Promise<ServiceResult<SubmitPackagingAdviceFormModel>> {
    try {
        const result = await post<SubmitPackagingAdviceFormApiParameter, SubmitPackagingAdviceFormModel>(
            `${baseUrl}/packagingadvice`,
            parameter,
        );

        return { successful: true, result };
    } catch (error) {
        return { successful: false, errorMessage: "" };
    }
}
